import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-tai-chi',
	options: {
		userTags: ['tai_chi_walking'],
		userFlags: ['hasAccessToWalkingVideos'],
	},
	landing: {
		ids: ['loader-tai-chi-f', 'age-tai-chi-f'],
		route: {
			path: '/tai-chi-f',
			name: 'female-tai-chi-funnel',
		},
	},
	funnel: {
		id: 'ob-female-tai-chi',
		route: {
			path: '/tai-chi-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-tai-chi',
		},
		slug: 'activity-female-tai-chi',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-f',
	},
	upsell: {
		routeNames: ['upsell-tai-chi-walking-f'],
	},
}

export default appAreaConfig
